import { X } from 'lucide-react';
import { brandColorVar } from '@/context/ScopeContext';
import TESTIDS from '@/constants/testIds';

export function BrandAccountChip({
    account,
    brand,
    selected = false,
    onClick,
    onRemove,
    testId,
    className = '',
}) {
    const slot = brand?.color_slot || 1;
    const handle = account?.handle || account?.display_name || 'unknown';
    const handleClick = (e) => {
        if (onClick) {
            e.preventDefault();
            onClick();
        }
    };
    return (
        <button
            type="button"
            onClick={handleClick}
            data-testid={testId || TESTIDS.composerAccountChip}
            data-selected={selected}
            className={`group inline-flex items-center gap-2 rounded-md border bg-[hsl(var(--surface-2))] px-2 py-1 text-[12px] transition-colors duration-150 hover:bg-[hsl(var(--surface-3))] focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none ${
                selected
                    ? 'border-[hsl(var(--brand-accent-current)/0.55)] bg-[hsl(var(--brand-accent-current)/0.14)]'
                    : 'border-border'
            } ${className}`}
            style={{ '--brand-accent-current': brandColorVar(slot) }}
        >
            <span
                className="inline-block h-2 w-2 rounded-full"
                style={{ backgroundColor: `hsl(${brandColorVar(slot)})` }}
                aria-hidden
            />
            <span className="font-mono text-[12px] tracking-tight text-foreground">
                @{handle}
            </span>
            {brand?.name ? (
                <span className="hidden text-[11px] text-muted-foreground sm:inline">
                    · {brand.name}
                </span>
            ) : null}
            {onRemove ? (
                <span
                    role="button"
                    tabIndex={-1}
                    onClick={(e) => {
                        e.stopPropagation();
                        onRemove();
                    }}
                    className="ml-1 inline-flex h-4 w-4 items-center justify-center rounded text-muted-foreground hover:bg-[hsl(var(--surface-3))] hover:text-foreground"
                    data-testid={`${testId || 'brand-account-chip'}-remove-button`}
                >
                    <X className="h-3 w-3" />
                </span>
            ) : null}
        </button>
    );
}
